export default {
  me: {
    id: null,
    email: null,
    roles: [],
    firstName: null,
    lastName: null,
  },
  myAgentsCount: 0,
  myAgentsSort: null,
  myAgentSortDesc: false,
  myBrokerage: null,
  agent: null,
  myLoanOffice: null,
  isLoadingMe: false,
  drawer: true,
  responsive: false,
  mobileBrokerSort: false,
  mobileAgentSort: false,
  mobileBrokerSearch: false,
  mobileAgentSearch: false,
  agentDetailsActiveTab: "details",
  brokerBoostStatus: {
    enabled: null,
    percentage: 0,
    timestamp: null,
  },
  userType: null, // user type is used for tracking as a "generic role" for GA4 analytics
};
